import type { LoadingValue, ProjectTileProps } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { Link } from '@remix-run/react';
import type ProjectTileItem from '@modules/tile/type/project-tile-item';
import getProjectTileProps from '@modules/tile/util/get-project-tile-props';
import * as S from './ProjectTile.style';
import type { SyntheticEvent } from 'react';
import React from 'react';
import type { FavouriteItem } from '~/modules/design-board/type/design-board-types';
import ProjectTile from './ProjectImpressionTile';
import { getImagesSizes } from '~/utils/image-sizes-utils';

export interface TileProps
    extends Pick<
        ProjectTileProps,
        'size' | 'variables' | 'variant' | 'topActions' | 'adminCaption'
    > {
    data: ProjectTileItem;
    tileCutOff?: boolean;
    imgLoading?: LoadingValue;
    onClick?: (e: SyntheticEvent) => void;
    favouriteItem: FavouriteItem;
    state?: {
        [key: string]: string;
    };
}

const ProjectTileWrapper = ({
    data,
    tileCutOff,
    size,
    variant,
    imgLoading = 'lazy',
    onClick,
    favouriteItem,
    ...rest
}: TileProps) => {
    const { css } = useStyles();

    const { projectLink, imageUrl, projectName, professional, professionalID } =
        getProjectTileProps(data);

    const projectTileClassName = tileCutOff
        ? css(S.ProjectTileCutoff)
        : css(S.ProjectTile);

    const projectId = data.ID as number;

    const imageSizes = getImagesSizes(588);

    return (
        <ProjectTile
            data-testid="project-tile"
            as={Link}
            prefetch="intent"
            to={projectLink}
            image={[
                {
                    src: imageUrl ?? '',
                    width: '100%',
                    height: '100%',
                    sizes: imageSizes,
                    layout: 'responsive',
                    loading: imgLoading,
                    alt: data?.Title,
                },
            ]}
            projectName={{
                children: projectName,
                maximumLines: 2,
            }}
            professionalName={professional}
            size={size}
            className={projectTileClassName}
            variant={variant}
            newDesignEnabled={true}
            onClick={onClick}
            onFavourite={(e) => {
                favouriteItem.onClick(e, projectId);
            }}
            isFavourited={favouriteItem.favourited(projectId)}
            {...rest}
            impression={{
                professionalID: professionalID ?? 0,
                itemID: projectId,
                type: 'LibraryItem_Directory',
            }}
        />
    );
};

export default ProjectTileWrapper;
